import React, {Component} from "react";
import Group, {GroupDescription, GroupHead} from "../../../Components/Group";
import Button from "../../../Components/Control/Button";
import './index.css';
import Grid, {GridButton, GridControls, gridDateTime, GridState, GridStates} from "../../../Components/Grid";
import {ModalAction} from "../../../Components/Modal";
import Resource from "../../../Resource";
import {Tool} from "../../../App";
import ModalHospital from "../../Modal/ModalHospital";
import Configuration from "../../../Server/Configuration";
import Notif from "../../../Components/Notif";
import {connect} from "react-redux";
import {updateBase} from "../../../Redux/Actions/base";
import Perms from '../../../Perms';

class PageHospitals extends Component {
    constructor (props) {
        super(props);

        if (!Perms().CONFIGURATION.HOSPITALS.VIEW)
            props.history.push(Resource.ROUTE.HOME);

        this.state = {
            grid: {
                columnDefs: [{
                    field: 'hospitalFullName',
                    headerName: 'نام کامل',
                    headerTooltip: 'نام کامل',
                    checkboxSelection: true,
                    headerCheckboxSelection: true,
                    filter: 'agTextColumnFilter'
                }, {
                    field: 'hospitalShortName',
                    headerName: 'نام کوتاه',
                    headerTooltip: 'نام کوتاه'
                }, {
                    field: 'hospitalPhoneNumber',
                    headerName: 'شماره تلفن',
                    headerTooltip: 'شماره تلفن',
                    cellRenderer: row => row.data.hospitalPhoneNumber || '-'
                }, {
                    field: 'hospitalMobileNumber',
                    headerName: 'شماره موبایل',
                    headerTooltip: 'شماره موبایل',
                    cellRenderer: row => row.data.hospitalMobileNumber || '-'
                }, {
                    field: 'hospitalFax',
                    headerName: 'شماره فکس',
                    headerTooltip: 'شماره فکس',
                    hide: true,
                    cellRenderer: row => row.data.hospitalFax || '-'
                }, {
                    field: 'provinceName',
                    headerName: 'استان',
                    headerTooltip: 'استان',
                    hide: true
                }, {
                    field: 'cityName',
                    headerName: 'شهر',
                    headerTooltip: 'شهر'
                }, {
                    field: 'hospitalAddress',
                    headerName: 'آدرس',
                    headerTooltip: 'آدرس',
                    hide: true
                }, {
                    field: 'createDateTime',
                    headerName: 'زمان ثبت',
                    headerTooltip: 'زمان ثبت',
                    valueGetter: gridDateTime.bind(this, 'date'),
                    cellRenderer: gridDateTime
                }, {
                    field: 'hospitalStatus',
                    headerName: 'وضعیت',
                    headerTooltip: 'وضعیت',
                    pinned: props.gridDefaultSettings.pinStatusColumn,
                    sortable: false,
                    enableRowGroup: false,
                    cellRenderer: 'state'
                }, {
                    headerName: 'عملیات',
                    headerTooltip: 'عملیات',
                    pinned: props.gridDefaultSettings.pinOperationColumn,
                    sortable: false,
                    filter: false,
                    minWidth: 120,
                    hide: !(Perms().CONFIGURATION.HOSPITALS.UPDATE || Perms().CONFIGURATION.HOSPITALS.ACTIVATE_DEACTIVATE),
                    enableRowGroup: false,
                    cellRenderer: 'control'
                }],
                frameworkComponents: {
                    state: row => {
                        return <GridStates>
                            {row.data.hospitalStatus === 'فعال' && <GridState theme={'green'}>فعال</GridState>}
                            {row.data.hospitalStatus === 'غیرفعال' && <GridState theme={'red'}>غیرفعال</GridState>}
                        </GridStates>;
                    },
                    control: row => {
                        return <GridControls>
                            {Perms().CONFIGURATION.HOSPITALS.UPDATE && <GridButton type={"button"} theme={'edit'} title={'ویرایش'} onClick={this.update.bind(this, row.data)}/>}
                            {row.data.hospitalStatus === 'فعال' && Perms().CONFIGURATION.HOSPITALS.ACTIVATE_DEACTIVATE && <GridButton type={"button"} theme={'red'} icon={Resource.IMAGE.PACK.PADLOCK.WHITE} title={'غیرفعال'} onClick={this.deactivate.bind(this, row.data)}/>}
                            {row.data.hospitalStatus === 'غیرفعال' && Perms().CONFIGURATION.HOSPITALS.ACTIVATE_DEACTIVATE && <GridButton type={"button"} theme={'green'} icon={Resource.IMAGE.PACK.OPEN_LOCK.WHITE} title={'فعال'} onClick={this.activate.bind(this, row.data)}/>}
                        </GridControls>;
                    }
                },
                getContextMenuItems: params => {
                    if (params.node)
                        return [{
                            name: 'ویرایش بیمارستان',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.EDIT1.BLACK}" alt="">`,
                            action: this.update.bind(this, params.node.data),
                            disabled: !Perms().CONFIGURATION.HOSPITALS.UPDATE
                        }, {
                            name: 'فعال سازی',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.OPEN_LOCK.BLACK}"/>`,
                            action: this.activate.bind(this, params.node.data),
                            disabled: params.node.data.hospitalStatus === 'فعال' || !Perms().CONFIGURATION.HOSPITALS.ACTIVATE_DEACTIVATE
                        }, {
                            name: 'غیرفعال سازی',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.PADLOCK.BLACK}"/>`,
                            action: this.deactivate.bind(this, params.node.data),
                            disabled: params.node.data.hospitalStatus === 'غیرفعال' || !Perms().CONFIGURATION.HOSPITALS.ACTIVATE_DEACTIVATE
                        },
                            'separator',
                            ...params.defaultItems];
                },
                onRowDoubleClicked: row => {
                    this.ref.modalHospital.current.open(row.data, ModalAction.VIEW);
                }
            },
            rowData: [],
            selectedRows: [],
            hospitalGrid: null
        };

        this.ref = {
            hospitalGrid: React.createRef(),
            modalHospital: React.createRef()
        };
    }

    shouldComponentUpdate (nextProps, nextState, nextContext) {
        return this.state.grid !== nextState.grid ||
            this.state.rowData !== nextState.rowData;
    }

    componentDidMount () {
        const {state, props} = this;

        const grid = Tool.applyGridDefaultSettings(props.gridDefaultSettings, state.grid);

        if (grid) {
            this.setState({grid});
        }
    }

    render () {
        return <React.Fragment>
            <Group className={'PageHospitals-group mar-10'}>
                <GroupHead title={'لیست بیمارستان‌ها'}>
                    {Perms().CONFIGURATION.HOSPITALS.INSERT && <Button className={'mar-s-4'} theme={'blue'} onClick={this.addClickHandler.bind(this)}>افزودن بیمارستان</Button>}
                </GroupHead>
                <GroupDescription>لیست بیمارستان‌های داخل سامانه از این قسمت قابل مشاهده می باشد.</GroupDescription>
                <Grid refer={this.ref.hospitalGrid } id={'hospitals'} {...this.state.grid} rowData={this.state.rowData} onGridReady={this.hospitalGridReadyHandler.bind(this)} onSelectionChanged={this.hospitalGridSelectionHandler.bind(this)}/>
            </Group>
            <ModalHospital refer={this.ref.modalHospital} onSuccess={this.updateGrid.bind(this)}/>
        </React.Fragment>;
    }

    addClickHandler () {
        this.ref.modalHospital.current.open(null, ModalAction.INSERT);
    }

    hospitalGridReadyHandler (params) {
        this.updateGrid();

        this.setState({hospitalGrid: params});
    }

    hospitalGridSelectionHandler (rows) {
        this.setState({selectedRows: rows});
    }

    updateGrid () {
        this.ref.hospitalGrid.current.loading();

        Configuration.hospitalsList()
            .then(list => {
                // Here i decided to update the fields.allHospitals in order to access updated data in other pages
                // fields.allHospitals will be updated in every page load so need instance update here
                this.props.updateBase({
                    allHospitals: list.map(item => {
                        return {id: item.hospitalId, shortName: item.hospitalShortName, fullName: item.hospitalFullName};
                    })
                });

                this.setState({rowData: list});
            })
            .catch(message => {
                this.ref.hospitalGrid.current.error();
            });
    }

    update (row) {
        this.ref.modalHospital.current.open(row, ModalAction.UPDATE);
    };

    activate (row, props = {loading: _ => null}) {
        props.loading();

        Configuration.updateHospital({
            hospitalId: row.hospitalId,
            shortName: row.hospitalShortName,
            fullName: row.hospitalFullName,
            provinceId: row.provinceId,
            cityId: row.cityId,
            address: row.hospitalAddress,
            phoneNumber: row.hospitalPhoneNumber,
            mobileNumber: row.hospitalMobileNumber,
            fax: row.hospitalFax,
            status: 1
        }).then(_ => {
            new Notif('بیمارستان با موفقیت فعال شد.').show();

            this.updateGrid();

            props.loading(false);
        }).catch(message => {
            new Notif(message).show();

            props.loading(false);
        });
    }

    deactivate (row, props = {loading: _ => null}) {
        props.loading();

        Configuration.updateHospital({
            hospitalId: row.hospitalId,
            shortName: row.hospitalShortName,
            fullName: row.hospitalFullName,
            provinceId: row.provinceId,
            cityId: row.cityId,
            address: row.hospitalAddress,
            phoneNumber: row.hospitalPhoneNumber,
            mobileNumber: row.hospitalMobileNumber,
            fax: row.hospitalFax,
            status: 0
        }).then(_ => {
            new Notif('بیمارستان با موفقیت غیرفعال شد.').show();

            this.updateGrid();

            props.loading(false);
        }).catch(message => {
            new Notif(message).show();

            props.loading(false);
        });
    }
}

const mapStateToProps = state => {
    return {
        gridDefaultSettings: state.grid.defaultSettings
    };
};

const mapDispatchToProps = dispatch => {
    return {
        updateBase: props => dispatch(updateBase(props))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PageHospitals);